module.exports = __webpack_public_path__ + "googlereviews2.jpg?c46f2459b5a074af969d973d2ef6811f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/googlereviews2.jpg
// module id = 3
// module chunks = 0